import React from 'react'

const UkMofaMain = () => {
  return (
 <div className="uaeMofaMainContainer">
      <p>
        We also take over Ministry of Foreign Affairs of UK After
        Attesting from country from which the documents are issued it has to be
        Attested from MOFA Ministry of Foreign Affairs of the Country where you
        are going for employment.
      </p>
    </div>
  )
}

export default UkMofaMain
